
import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Link, LinkWithArrow } from 'newComponents'
import quoteMarks from '../../images/blog/quote-marks.png'
import './styles.scss'

const TextGrid = (props) => {
  const { data } = props
  const { primary, items } = data
  const { cta_link: ctaLink, cta_text: ctaText } = primary

  // content checks
  const hasCta = ctaLink?.url && ctaText?.text
  return (
    <OnVisible className="text-grid">
      <Section>
        <div className="text-grid-container">
          {items.map((item) => {
            const { content, title, cta_text: linkText, cta_link: linkUrl } = item
            const titleHtml = title?.html
            const contentHtml = content?.html
            const contentText = content?.text
            const hasLink = linkUrl?.url && linkText?.text
            return (
              <div className="text-grid-section" key={contentText.slice(0, 40)}>
                {titleHtml && <div className="text-grid-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
                {contentHtml && <div className="text-grid-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
                {hasLink && (
                  <LinkWithArrow to={linkUrl.url} left>
                    {linkText.text}
                  </LinkWithArrow>
                )}
              </div>
            )
          })}
        </div>
        {hasCta && (
          <LinkWithArrow to={ctaLink.url} className="text-grid-cta">
            {ctaText.text}
          </LinkWithArrow>
        )}
      </Section>
    </OnVisible>
  )
}

export default TextGrid
